<h1 mat-dialog-title>Message</h1>
<mat-dialog-content> {{message}} </mat-dialog-content>
<mat-dialog-actions>
  <button mat-raised-button (click)="closeMe()">Close</button>
</mat-dialog-actions>